import { useEffect, useState } from "react";
import {UNIT_API_URL} from "../Const";


const UNIT_STORAGE_KEY = "productUnitsCache";
const UNIT_STORAGE_TIME_KEY = "productUnitsCacheTime";
const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 ساعت به میلی‌ثانیه
export function useProductUnits() {
    const [units, setUnits] = useState(() => {
        const cached = localStorage.getItem(UNIT_STORAGE_KEY);
        const cachedTime = localStorage.getItem(UNIT_STORAGE_TIME_KEY);

        if (cached && cachedTime) {
            const now = Date.now();
            const age = now - parseInt(cachedTime, 10);

            // اگر کمتر از 24 ساعت گذشته باشه، کش معتبره
            if (age < CACHE_DURATION) {
                return JSON.parse(cached);
            }
        }
        return null; // اگر کش معتبر نباشه، null
    });

    const [loading, setLoading] = useState(!units);
    const [error, setError] = useState(null);


    useEffect(() => {
            if (!units) {
                fetchUnits();
            }
        }, [units]);

        function fetchUnits() {
            setLoading(true);
            setError(null);

            fetch(UNIT_API_URL, {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("pwa_token"),
                    "Content-Type": "application/json",
                },
            })
                .then((res) => {
                    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
                    return res.json();
                })
                .then((data) => {
                    setUnits(data);
                    localStorage.setItem(UNIT_STORAGE_KEY, JSON.stringify(data.data));
                    localStorage.setItem(UNIT_STORAGE_TIME_KEY, Date.now().toString()); // ذخیره زمان
                    setLoading(false);
                })
                .catch((err) => {
                    setError(err.message || "Failed to fetch product units");
                    setLoading(false);
                });
        }
    useEffect(() => {
        // If no units cached, fetch from API
        if (!units) {
            setLoading(true);
            fetch(UNIT_API_URL, {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                    'Content-Type': 'application/json',
                }
            })
                .then((res) => {
                    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
                    return res.json();
                })
                .then((data) => {
                    setUnits(data);
                    localStorage.setItem(UNIT_STORAGE_KEY, JSON.stringify(data.data));
                    setLoading(false);
                })
                .catch((err) => {
                    setError(err.message || "Failed to fetch product units");
                    setLoading(false);
                });
        }
    }, [units]);

    // Function to manually refresh units (optional)
    function refreshUnits() {
        setLoading(true);
        setError(null);
        fetch(UNIT_API_URL)
            .then((res) => {
                if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
                return res.json();
            })
            .then((data) => {
                setUnits(data);
                localStorage.setItem(UNIT_STORAGE_KEY, JSON.stringify(data));
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message || "Failed to fetch product units");
                setLoading(false);
            });
    }
    

    return { units, loading, error, refreshUnits };

}

